import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { Ciudad } from './../models/ciudad.interface';
import { Injectable } from '@angular/core';
import { Estado } from '../models/estado.interface';
import { BaseService } from './base.service';
import { BaseState } from './base.state';
import { FarmaciaEnlace } from '../models/farmacia-enlace.interface';
import { takeUntil } from 'rxjs/operators';
import { HistorialFarmaciaRequest } from '../models/historial-farmacia-request.interface';
import { HttpResponse, HttpParams } from '@angular/common/http';
import { Banner } from '../models/banner.interface';

@Injectable({
  providedIn: 'root'
})
export class EnlacesService {

  private estadoState: BaseState<Estado[]> = new BaseState<Estado[]>();
  private ciudadState: BaseState<Ciudad[]> = new BaseState<Ciudad[]>();
  private farmaciaEnlaceState: BaseState<FarmaciaEnlace[]> = new BaseState<FarmaciaEnlace[]>();
  private bannersState: BaseState<Banner[]> = new BaseState<Banner[]>();

  constructor(private baseService: BaseService) { }

  public getEstados$(): Observable<Estado[] | null> {
    return this.estadoState.getState$();
  }

  public getCiudades$(): Observable<Ciudad[] | null> {
    return this.ciudadState.getState$();
  }

  public getFarmaciasEnlace$(): Observable<FarmaciaEnlace[] | null> {
    return this.farmaciaEnlaceState.getState$();
  }

  public getUpdatingEstados$(): Observable<boolean> {
    return this.estadoState.isUpdating$();
  }

  public getUpdatingCiudades$(): Observable<boolean> {
    return this.ciudadState.isUpdating$();
  }

  public getUpdatingFarmaciasEnlace$(): Observable<boolean> {
    return this.farmaciaEnlaceState.isUpdating$();
  }

  public getBanners$(): Observable<Banner[] | null> {
    return this.bannersState.getState$();
  }

  public getUpdatingBanners$(): Observable<boolean> {
    return this.bannersState.isUpdating$();
  }

  public getEstadosAPI(unsubscribe: Subject<void>): void {
    const httpParams = new HttpParams();
    const params = httpParams.set("modelo", environment.modelo.toString());

    this.estadoState.setUpdating(true);
    this.baseService.getAPI<Estado[]>(`enlaces/estados`, params)
      .pipe(takeUntil(unsubscribe))
      .subscribe(
        (estados: Estado[]) => this.estadoState.setState(estados),
        (err) => console.log(err),
        () => this.estadoState.setUpdating(false));
  }

  public getCiudadesAPI(estadoId: number, unsubscribe: Subject<void>): void {
    const httpParams = new HttpParams();
    const params = httpParams.set("modelo", environment.modelo.toString());

    this.ciudadState.setUpdating(true);
    this.baseService.getAPI<Ciudad[]>(`enlaces/ciudades/${estadoId}`, params)
      .pipe(takeUntil(unsubscribe))
      .subscribe(
        (ciudades: Ciudad[]) => this.ciudadState.setState(ciudades),
        (err) => console.log(err),
        () => this.ciudadState.setUpdating(false));
  }

  public getFarmaciasEnlaceAPI(ciudadId: number, unsubscribe: Subject<void>): void {
    const httpParams = new HttpParams();
    const params = httpParams.set("modelo", environment.modelo.toString());

    this.farmaciaEnlaceState.setUpdating(true);
    this.baseService.getAPI<FarmaciaEnlace[]>(`enlaces/${ciudadId}`, params)
      .pipe(takeUntil(unsubscribe))
      .subscribe(
        (farmaciasEnlace: FarmaciaEnlace[]) => this.farmaciaEnlaceState.setState(farmaciasEnlace),
        (err) => console.log(err),
        () => this.farmaciaEnlaceState.setUpdating(false));
  }

  public getBannersAPI(tipoBanner: string, unsubscribe: Subject<void>) {
    const httpParams = new HttpParams();
    const params = httpParams.set('tipoBanner', tipoBanner);

    this.bannersState.setUpdating(true);
    this.baseService.getAPI<Banner[]>(`enlaces/banners`, params)
      .pipe(takeUntil(unsubscribe))
      .subscribe(
        (banners: Banner[]) => this.bannersState.setState(banners),
        (err) => console.log(err),
        () => this.bannersState.setUpdating(false));
  }

  public postHistorialFarmaciaAPI(historialFarmacia: HistorialFarmaciaRequest): Observable<any> {
    return this.baseService.postAPI<HttpResponse<Object>>(`enlaces/historial`, historialFarmacia);
  }

}
